import { facadeApi } from 'api'
import { FileItem } from 'types/files/files'

export const fetchFileApi = ({ id }: { id: string }) => facadeApi.get<FileItem>(`file-manager/v1/files/${id}`)
